<template>
  <div
    v-show="from === 'detail' || visible"
    :class="[
      'wiki-cata-log',
      from === 'detail' ? 'detail-cata-log' : '',
      from === 'detail' && !visible ? 'recommend' : ''
    ]"
    ref="recommendBox"
    :style="calcCustomStyle"
  >
    <!-- top -->
    <slot name="top"></slot>
    <!-- 相关推荐 -->
    <div v-if="!visible" class="recommend-box">
      <div class="header">相关推荐</div>
      <div class="card-box">
        <template v-if="recommendList && recommendList.length">
          <template v-for="(item, index) in recommendList.slice(0, 10)">
            <div @click="onAdJump(item)" :key="index" v-if="item.is_ad" class="ad-item">
              <span>广告</span>
              <img class="cover" :src="item.thumb" alt="" />
            </div>
            <router-link v-else :to="getJumpWikiDetailUrl(gameInfo.alias, gameInfo.id, item.id, true)" target="_blank">
              <div :key="index" class="card-item">
                <div class="card-title">{{ item.title }}</div>
                <div class="des">{{ deleteHtmlStr(item.summary) }}</div>
                <div class="img-wrapper" v-if="item.thumb && item.thumb_list && item.thumb_list.length">
                  <template v-for="(img, index) in item.thumb_list">
                    <div v-if="index < 3" :key="index" class="img-item">
                      <img v-lazy="handleImgSize(img, 'small')" alt="" />
                      <div v-if="index == 2 && item.thumb_list.length > 3" class="mask">
                        +{{ item.thumb_list.length - 3 }}
                      </div>
                    </div>
                  </template>
                </div>
                <div class="user-line">
                  <span class="user">
                    <img v-lazy="handleImgSize(item.user.avatar, 'mini')" alt="" />
                    <span class="name">{{ item.user.username }}</span>
                  </span>
                  <div class="info">
                    <span style="margin-right: 20px;"><i class="iconfont icon-chayue" /> {{ item.view_count }}</span>
                    <span><i class="iconfont icon-dianzan" /> {{ item.like_count }}</span>
                  </div>
                </div>
              </div>
            </router-link>
            <!-- <google-ad class="mB12" v-if="index === 0 && !['pz','dzxy','reverse1999','archeland'].includes(gameInfo.alias)">
              <ins class="adsbygoogle"
                   style="display:inline-block;width:300px;height:202px"
                   data-ad-client="ca-pub-7139243743736639"
                   data-ad-slot="1064329991"></ins>
            </google-ad> -->
          </template>
        </template>
        <template v-else>
          <div class="card-item">
            暂无相关推荐~
          </div>
          <!-- <google-ad class="mB12" v-if="!['pz','dzxy','reverse1999','archeland'].includes(gameInfo.alias)">
            <ins class="adsbygoogle"
                 style="display:inline-block;width:300px;height:202px"
                 data-ad-client="ca-pub-7139243743736639"
                 data-ad-slot="1064329991"></ins>
          </google-ad> -->
        </template>
      </div>
    </div>
    <!-- 目录 -->
    <div class="catalog-box" v-else>
      <div class="title">
        目录
      </div>
      <el-scrollbar class="list-box" @wheel.stop>
        <div v-for="(item, index) in cataList" :key="index">
          <h2 class="item" v-if="item.secondLevelLen <= 0">
            <div class="dot"></div>
            <div class="value" @click="handleDataId(item)">
              {{ item.title }}
            </div>
          </h2>
          <h3 class="second-item" v-else>
            <div class="dot"></div>
            <div class="value" @click="handleDataId(item)">
              {{ item.title }}
            </div>
          </h3>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import eventBus from "@/plugins/eventBus";
// import $ from 'jquery';
// import GoogleAd from "@/views/wiki/components/googleAd.vue";
// import googleAd from '@/views/wiki/components/googleAd.vue';
import { mapGetters } from "vuex";
import { getJumpWikiDetailUrl } from "../../../plugins/util";

export default {
  name: "wikiCataLog",
  components: {
    // GoogleAd
  },
  props: {
    from: {
      type: String,
      default: ""
    },
    customStyle: {
      type: Object,
      default: () => ({})
    },
    recommendList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["gameInfo"])
    // getContentText () {
    //   return (html) => {
    //     let $content = document.createElement('div');
    //     $content.innerHTML = html;
    //     return $content.innerText;
    //   };
    // },
    // getContentImgs () {
    //   return (html) => {
    //     let $content = document.createElement('div');
    //     $content.innerHTML = html;
    //     let imgs = [];
    //     $content.querySelectorAll('img').forEach((img) => {
    //       imgs.push(img.getAttribute('src'));
    //     });
    //     return (imgs && imgs.length) ? imgs : null;
    //   };
    // }
  },
  data() {
    return {
      visible: false,
      cataList: [],
      scrollY: 0,
      calcCustomStyle: {}
    };
  },
  mounted() {
    eventBus.$on("setCataVisible", this.handleVisible);
    eventBus.$on("setCataList", this.handleList);
    setTimeout(() => {
      const detailUserCardHeight = document.querySelector(".wiki-detail-user").clientHeight;
      // console.log(detailUserCardHeight);
      this.initTop = detailUserCardHeight + 80 + 28;
      this.initStyle = {
        top: this.initTop + "px"
      };
    }, 500);
    window.addEventListener("scroll", this.winScroll);
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {
    eventBus.$off("setCataVisible");
    eventBus.$off("setCataList");

    window.removeEventListener("scroll", this.winScroll);
  },
  methods: {
    getJumpWikiDetailUrl,
    // 服务端渲染，替代getContentText
    deleteHtmlStr(str = "") {
      return str.replace(/<[^>]*>/g, "");
    },
    // 服务端渲染，替代getContentImgs
    getContentImgs(str = "") {
      const patten = /<img[^>]+src=['"]([^'"]+)['"]+/g;
      let imgs = [];
      let temp = null;
      while ((temp = patten.exec(str)) != null) {
        imgs.push(temp[1]);
      }
      return imgs && imgs.length ? imgs : null;
    },
    onAdJump(item) {
      if (!item.jump_url) return;
      window.open(item.jump_url, "_blank");
    },
    handleVisible(val) {
      // console.log(val);
      this.visible = val || false;
    },
    handleItem(data) {
      const url = `${window.location.origin}/${data.id}.html`;
      window.open(url, "_blank");
    },
    handleList(val) {
      this.cataList = val || [];
    },
    handleDataId(data) {
      const id = data.dataId;
      // const wikiBody = document.getElementById('wiki-body');
      if (id) {
        let offsetTop = $(id).get(0).offsetTop;
        if (this.from === "detail") {
          offsetTop += 66;
          window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
          });
        } else if (this.from === "wikiHome") {
          const dom = document.getElementById("rightScroll");
          if (dom) {
            dom.scrollTo({
              top: offsetTop,
              behavior: "smooth"
            });
          }
        }
      }
    },
    winScroll(e) {
      this.scrollY = window.document.documentElement.scrollTop || window.document.body.scrollTop;

      this.calcCustomStyle = this.getCalcCustomStyle();
    },
    getCalcCustomStyle() {
      if (this.from === "detail") {
        const recommendBox = this.$refs.recommendBox;
        const screenHeight = window.screen.height - 54;
        const recommendHeight = recommendBox ? recommendBox.offsetHeight : 0;
        // console.log(this.scrollY, this.visible, screenHeight, recommendHeight);
        if (!this.visible && this.scrollY > 146) {
          if (recommendHeight + 212 < screenHeight) {
            return {
              ...this.customStyle,
              top: (this.scrollY - 64).toFixed() + "px"
            };
          } else {
            // 这个时候让右侧推荐跟着滚动
            if (recommendHeight + 212 + 80 + 54 + 200 - screenHeight < this.scrollY) {
              const top = (this.scrollY - recommendHeight - 212 - 80 - 200 + 28 + screenHeight).toFixed();
              return {
                ...this.customStyle,
                top: top + "px"
              };
            }
          }
        }
        if (this.visible && this.scrollY > 146) {
          return {
            ...this.customStyle,
            top: (this.scrollY - 64).toFixed() + "px"
          };
        } else {
          return {
            ...this.customStyle
          };
        }
      } else {
        return {
          ...this.customStyle
        };
      }
    }
  }
};
</script>
<style lang="less" scoped>
.wiki-cata-log {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: auto;
  right: 0;
  margin-top: 74px;
  transform: translateX(100%);
  margin-left: 0;
  width: 218px;
  background: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  &.detail-cata-log {
    position: absolute;
    top: 81px;
    right: 72px;
    width: 300px;
    margin-top: 0;
    transform: translateX(0);

    // transition: all ease 0.1s;
    &.recommend {
      max-height: none;
      overflow: visible;
      border: none;
      background: none;
      .recommend-box {
        .header {
          margin-bottom: 12px;
          color: #333;
          font-size: 16px;
          font-weight: 500;
        }
        .card-box {
          display: flex;
          flex-direction: column;
          width: 100%;
          a {
            margin-bottom: 12px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .card-item {
            width: 100%;
            // height: 204px;
            padding: 20px 28px 15px 28px;
            box-sizing: border-box;
            background-color: #fbfbfb;
            border: 1px solid #e8e8e8;
            border-radius: 4px;
            cursor: pointer;
            .card-title {
              .ellipsis;
              margin-bottom: 8px;
              color: #333;
              font-size: 14px;
            }
            .des {
              margin-bottom: 12px;
              color: #999;
              font-size: 12px;
              line-height: 17px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
            .img-wrapper {
              display: flex;
              margin-bottom: 16px;
              .img-item {
                width: 60px;
                height: 60px;
                cursor: pointer;
                position: relative;
                border-radius: 4px;
                overflow: hidden;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }

                & + .img-item {
                  margin-left: 8px;
                }

                .mask {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  background: fade(#000, 70%);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #fff;
                  font-size: 16px;
                }
              }
            }
            .user-line {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              overflow: hidden;
              .user {
                .ellipsis;
                display: flex;
                align-items: center;
                flex: 1;
                img {
                  flex: 0 0 auto;
                  width: 20px;
                  height: 20px;
                  border-radius: 50%;
                  object-fit: cover;
                  margin-right: 8px;
                }
                .name {
                  .ellipsis;
                  flex: 1;
                  margin-top: 2px;
                  color: #666;
                  font-size: 12px;
                }
              }
              .info {
                flex: 0 0 auto;
                color: #666;
                font-size: 12px;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
  }
  .catalog-box {
    display: flex;
    flex-direction: column;
    max-height: 440px;
    overflow: hidden;
    box-shadow: none;
    background-color: #fbfbfb;
    border: 1px solid #e8e8e8;
    .title {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      padding: 0 20px;
      height: 42px;
      color: #333;
      font-size: 16px;
      font-weight: 500;
      border-bottom: 1px solid #ebebeb;
    }
    .list-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;
      .item {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        width: 100%;
        height: 40px;
        padding: 0 16px;
        box-sizing: border-box;
        .dot {
          width: 6px;
          height: 6px;
          background-color: #d8d8d8;
          border-radius: 50%;
        }
        .value {
          flex: 1;
          margin-left: 10px;
          color: #333;
          font-size: 12px;
          font-weight: 400;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
      }
      .second-item {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        height: 28px;
        padding: 0 16px;
        padding-left: 36px;
        .left-line {
          width: 1px;
          height: 100%;
          margin-right: 5px;
          background-color: #d0d0d0;
        }
        .dot {
          width: 3px;
          height: 3px;
          background-color: #d8d8d8;
          border-radius: 50%;
        }
        .value {
          flex: 1;
          margin-left: 6px;
          color: #666;
          font-size: 12px;
          font-weight: 400;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
      }
    }
  }
}
.ad-item {
  position: relative;
  cursor: pointer;
  margin-bottom: 12px;
  span {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 1;
    color: #fff;
    font-size: 12px;
    background: rgba(0, 0, 0, 0.54);
    padding: 0 2px;
  }
  img {
    width: 100%;
    border-radius: 6px;
  }
}
</style>
